const initialState = {
  uploadModal: false,
  updateModal: false,
  deleteModal: false,
  informationModal: false,
  myPlaylistModal: false,
  shareModal: false,
  data: {},
};

export default initialState;
